import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StyledMessage from './StyledMessage';
import {
  clearfix,
  crossScreenMarginBottom,
  crossScreenPaddingRight,
  crossScreenWidth,
} from '../../../../../utils/styles';
import imageAvatar from '../img/avatar.png';

const Styled = styled(StyledMessage)`
  ${clearfix};
  ${crossScreenMarginBottom(114)};

  ${props =>
    props.index === 1 &&
    css`
      ${crossScreenMarginBottom(34)};
    `};
`;

const Inner = styled.div`
  position: relative;
  float: right;

  ${props =>
    props.index === 1 &&
    css`
      ${crossScreenPaddingRight(92)};
    `};
`;

const Text = styled.div`
  text-align: right;
`;

const Avatar = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  height: auto;
  ${crossScreenWidth(60)};
`;

class BotMessage extends React.Component {
  static propTypes = {
    messageRef: PropTypes.func,
  };

  componentDidMount() {
    this.props.messageRef && this.props.messageRef(this.node);
  }

  render() {
    const { children, index, ...rest } = this.props;

    return (
      <Styled {...rest} innerRef={node => (this.node = node)} data-question>
        <Inner index={index}>
          <Text>{children}</Text>
          {index === 1 && <Avatar src={imageAvatar} alt="Avatar" />}
        </Inner>
      </Styled>
    );
  }
}

export default BotMessage;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/components/BotMessage.js